import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  IN_ROOM_DINING_COMBO_CREATE,
  IN_ROOM_DINING_COMBO_VIEW,
  IN_ROOM_DINING_COMBO_ADDONS_GROUPED,
  IN_ROOM_DINING_COMBO_ADDONS_INACTIVE,
  IN_ROOM_DINING_COMBO_ADDONS_UNGROUPED,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import WarningPopup from '../../../../../shared/warning-popup/Warning-Popup';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import {
  activateInRoomDiningCombo,
  deactivateInRoomDiningCombo,
  deleteInRoomDiningCombo,
  deleteSelectedItems,
  updateSelectedItemsStatus,
  uploadIRDComboByCSV,
  createInRoomDiningCombo,
} from '../../../../../utils/ServicesAPIUtils';
import {
  fetchAllInRoomDining,
  inRoomDiningCombosSelector,
  inRoomDiningMenuSelector,
  setInRoomDiningCombo,
  inRoomDiningItemsSelector,
  inRoomDiningAddOnSelector,
} from '../../../servicesSlice';
import InRoomDiningComboListTable from './Combo-List-Table';
import {
  getCheckedIds,
  updateCheckedStatus,
  validateAlphanumeric,
  generateConfirmationMessage,
  ResetFilterList,
  selectedCheckList,
  isDragDisabled,
} from '../../../../../utils/formUtils';
import { Dialog } from '@mui/material';
import CsvUploader from '../../../../../shared/csv-uploader/Csv-Uploader';
import { allHotelsSelector } from '../../../../property/propertySlice';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { DOWNLOAD_ASSETS_URL } from '../../../../../env/Configurations';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const InRoomDiningComboList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    hotelId,
    restaurantId,
    inRoomDiningLoader,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    isHideAddButton = false,
  } = props;
  const inRoomDiningCombos = useSelector(inRoomDiningCombosSelector);
  const selectedHotel = useSelector(allHotelsSelector);
  const inRoomDiningMenu = useSelector(inRoomDiningMenuSelector);
  const originalAddons = useSelector(inRoomDiningAddOnSelector);
  const itemsListData = useSelector(inRoomDiningItemsSelector);
  const [combosList, setCombosList] = useState([]);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    warn: false,
    anchorEl: null,
  });
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(hotelId);
  const [popUp, setPopUp] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [uploadState, setUploadState] = useState(false);
  const [csvUploadStatus, setCsvUploadStatus] = useState(false);
  const [csvUploadErrorMsg, setCsvUploadErrorMsg] = useState(null);
  const [csvValidateError, setCsvValidateError] = useState(false);
  const [dataExistError, setDataExistError] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [actionName, setActionName] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);

  useEffect(() => {
    setCombosList((prevList) => {
      return inRoomDiningCombos?.map((combo) => {
        const isChecked = selectedCheckList(prevList, combo.id);
        return {
          ...combo,
          isChecked: isChecked,
        };
      });
    });
    setSearchText('');
  }, [inRoomDiningCombos]);

  useEffect(() => {
    if (inRoomDiningLoader || combosList?.length === 0) return;
    const totalItems = combosList?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [combosList?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== hotelId) {
      onsetPage(0);
    }
    prevHotelIdRef.current = hotelId;
  }, [hotelId]);

  const getCheckedComboList = combosList?.filter((combo) => combo?.isChecked);
  const listOfBundleIds = getCheckedComboList?.map((combo) => combo?.id);
  const selectedComboLength = getCheckedComboList?.length;

  const handleSearchText = async (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(combosList, 'isChecked');
    const filteredRows = await inRoomDiningCombos.filter((item) => {
      return item.name.toLowerCase().includes(searchText.toLowerCase());
    });
    onsetPage(0);
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    setCombosList(updatedCheckedList);
    if (searchText && (isAllSelected || selectedComboLength > 0)) {
      setShowBulkSearchAlert(true);
    } else if (!searchText) {
      setShowBulkSearchAlert(false);
      setCombosList(ResetFilterList);
    }
  };

  const dragDisabled = isDragDisabled(combosList, searchText);

  const onOpenDrawer = (event, type) => {
    if (selectedComboLength) {
      setCombosList(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.combo);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      warn: false,
      anchorEl: null,
      combo: null,
    });
  };

  const onClickRowViewDetails = (comboItem, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(IN_ROOM_DINING_COMBO_VIEW, true, comboItem);
    }
  };

  const onViewDetails = () => {
    onViewToggle(IN_ROOM_DINING_COMBO_VIEW, true, selectedValue.combo);
  };

  const handleCellMenuClick = (event, combo) => {
    if (selectedComboLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: combo.id,
        name: '',
        title: '',
        description: '',
        status: false,
        warn: false,
        anchorEl: event.currentTarget,
        combo,
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onActiveDeActiveCombo = async (e, type) => {
    e.preventDefault();
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      if (type === 'deactivate') {
        await deactivateInRoomDiningCombo(selectedValue.id, hotelId, restaurantId, language);
      } else {
        await activateInRoomDiningCombo(selectedValue.id, hotelId, restaurantId, language);
      }
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager(
        'success',
        `Combo ${type === 'deactivate' ? 'deactivated' : 'activated'} successfully`,
      );
      handleClose();
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : `Combo not ${type} `,
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDelete = async () => {
    try {
      dispatch(stepUpLoaderCount());
      if (selectedValue && selectedValue?.id) {
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        await deleteInRoomDiningCombo(selectedValue.id, hotelId, restaurantId, language);
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        notificationManager('success', 'Combo deleted successfully');
      }
      handleClose();
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Combo deleted successfully',
      );
      handleClose();
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const checkUsageInCategories = () => {
    let isUsed = inRoomDiningMenu.some((ird) =>
      ird.categories.some((category) =>
        category.items.some((item) => item.id === selectedValue.id),
      ),
    );
    return isUsed;
  };

  const checkUsageInSubCategories = () => {
    let isUsed = inRoomDiningMenu.some((ird) =>
      ird.categories.some((category) =>
        category.subCategories.some((subCategory) =>
          subCategory.items.some((item) => item.id === selectedValue.id),
        ),
      ),
    );
    return isUsed;
  };

  const onDeleteCombo = (event) => {
    if (checkUsageInCategories() || checkUsageInSubCategories()) {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        description: 'The selected combo cannot be deleted as it is being added to a Menu',
        status: false,
        warn: true,
        anchorEl: null,
      }));
    } else {
      event.preventDefault();
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        name: prev.combo.name,
        description: 'This action cannot be reversed.',
        status: true,
        warn: false,
        anchorEl: null,
      }));
    }
  };

  const onDeleteCancel = () => {
    handleClose();
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleUploadDialogClose = (e) => {
    dispatch(fetchAllInRoomDining(hotelId, restaurantId));
    setCsvUploadStatus(null);
    setUploadState(false);
  };
  const onClickUpload = (e) => {
    setUploadState(true);
  };

  const isAvailable = (data, originalItem) => {
    const convertedItems = originalItem && originalItem.map((x) => x.name.toLowerCase());
    const containsAll = data?.every((element) => {
      return convertedItems.includes(element.toLowerCase().trim());
    });
    return containsAll;
  };

  let findDuplicates = (arr) => arr.filter((item, index) => arr.indexOf(item) !== index);

  const normalizeAddOnType = (t) => {
    const s = (t || '')?.toString()?.trim()?.toLowerCase();
    if (!s) return '';
    if (['grouped', 'group', 'grp', 'g'].includes(s)) return 'grouped';
    if (['ungrouped', 'un-grouped', 'ungroup', 'u'].includes(s)) return 'ungrouped';
    if (['inactive', 'off', 'none', 'n/a', 'na', '0', 'false', 'no'].includes(s)) return 'inactive';
    return s;
  };
  const inferAddOnTypeFromValue = (v) => {
    const s = (v || '')?.toString()?.trim();
    if (!s) return 'inactive';
    const looksGrouped =
      s?.includes('/') && s?.split('/')?.every((seg) => seg?.split('-')?.length === 3);
    if (looksGrouped) return 'grouped';
    if (s?.includes('-') || s?.includes(',')) return 'ungrouped';
    return 'inactive';
  };
  const buildAddOns = (typeRaw, valueRaw, originalAddons, validateAlphanumeric) => {
    const addonNameSet = new Set(
      (originalAddons || [])?.map((x) => (x?.name || '')?.toLowerCase()),
    );
    const toIdListByName = (names) => {
      const want = new Set(names?.map((n) => n?.toLowerCase()));
      return originalAddons
        ?.filter((x) => want?.has((x?.name || '')?.toLowerCase()))
        ?.map((e) => e.id);
    };
    const splitNames = (s) =>
      (s || '')
        ?.toString()
        ?.split(',')
        ?.map((t) => t.trim())
        ?.filter(Boolean);
    const type = normalizeAddOnType(typeRaw) || inferAddOnTypeFromValue(valueRaw);
    const raw = (valueRaw || '')?.toString()?.trim();
    const inactive = { type: IN_ROOM_DINING_COMBO_ADDONS_INACTIVE, limit: false };

    if (type === 'grouped') {
      const groups = raw
        .split('/')
        .map((s) => s.trim())
        .filter(Boolean);
      const groupedAddon = [];
      for (const g of groups) {
        const parts = g.split('-');
        if (parts.length !== 3) continue;
        const title = (parts[0] || '').trim();
        const limitStr = (parts[1] || '').trim();
        const listStr = (parts[2] || '').trim();
        if (!title || !validateAlphanumeric(title)) continue;
        const names = splitNames(listStr)?.filter((n) => addonNameSet?.has(n?.toLowerCase()));
        if (names.length === 0) continue;
        const ids = toIdListByName(names);
        const limitNum = Math.max(1, Math.min(parseInt(limitStr, 10) || names.length, ids.length));
        groupedAddon.push({ title, limit: limitNum, addons: ids });
      }
      return groupedAddon.length > 0
        ? { type: IN_ROOM_DINING_COMBO_ADDONS_GROUPED, groupedAddon }
        : inactive;
    }

    if (type === 'ungrouped') {
      if (raw.includes('-')) {
        const [limitStr, listStr] = raw?.split('-').map((s) => s.trim());
        const names = splitNames(listStr)?.filter((n) => addonNameSet?.has(n?.toLowerCase()));
        if (names.length === 0) return inactive;
        const ids = toIdListByName(names);
        const limitNum = Math.max(1, Math.min(parseInt(limitStr, 10) || names.length, ids.length));
        return {
          type: IN_ROOM_DINING_COMBO_ADDONS_UNGROUPED,
          addons: ids,
          limit: true,
          value: limitNum,
        };
      } else {
        const names = splitNames(raw).filter((n) => addonNameSet.has(n.toLowerCase()));
        if (names.length === 0) return inactive;
        const ids = toIdListByName(names);
        const resObj = {
          type: IN_ROOM_DINING_COMBO_ADDONS_UNGROUPED,
          addons: ids,
          limit: false,
        };
        return resObj;
      }
    }

    return inactive;
  };

  const isNumber = (n) => {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  };

  const normalizeNumber = (s) => {
    const digits = String(s ?? '')?.replace(/[^\d]/g, '');
    return digits ? parseInt(digits, 10) : NaN;
  };
  const truthyWord = (v) =>
    ['yes', 'active', 'true', 'y', '1']?.includes((v || '')?.toString()?.trim()?.toLowerCase());
  const falsyWord = (v) =>
    ['no', 'inactive', 'false', 'n', '0'].includes((v || '')?.toString()?.trim()?.toLowerCase());
  const toLowerSet = (arr) => new Set((arr || []).map((x) => x?.toString()?.trim()?.toLowerCase()));
  const asBooleanOrList = (raw) => {
    const s = (raw || '')?.toString()?.trim();
    if (!s) return { active: false, names: [] };
    if (truthyWord(s)) return { active: true, names: [] };
    if (falsyWord(s)) return { active: false, names: [] };
    const names = s
      ?.split(',')
      ?.map((t) => t.trim())
      ?.filter(Boolean);
    return { active: names.length > 0, names };
  };
  const isValidStatus = (status) => {
    const v = (status || '').toString().trim().toLowerCase();
    return ['yes', 'no', 'active', 'inactive', 'true', 'false', 'y', 'n', '1', '0'].includes(v);
  };
  const handleCsvFileData = (rows) => {
    const isTemplateInstructionRow = (row) => {
      const values = Object.values(row).map((v) => String(v || '').toLowerCase().trim());
      const joined = values.join(' ');
      const instructionPatterns = [
        'character limit', 'mandatory', 'alphanumeric', 'alpha-numeric',
        'enter the', 'fill in', 'e.g.', 'example:', 'max characters',
        'max char', 'required field', 'this field', 'drop down', 'dropdown',
        'select from', 'free text', 'auto populate', 'auto-populate',
      ];
      if (values.some((s) => s.startsWith('*') && instructionPatterns.some((p) => s.includes(p)))) return true;
      if (instructionPatterns.filter((p) => joined.includes(p)).length >= 2) return true;
      return false;
    };
    const filtered = rows.filter((row) => !isTemplateInstructionRow(row));
    const errors = [];
    if (filtered.length === 0) {
      errors.push('No data rows found in the uploaded file.');
      setValidationErrors(errors);
      setCsvValidateError(true);
      return;
    }
    const itemNameSet = toLowerSet(itemsListData?.map((x) => x.name));
    const addonNameSet = toLowerSet(originalAddons?.map((x) => x.name));
    const parsePrice = (v) => {
      const s = String(v ?? '').trim();
      if (!s) return NaN;
      return parseFloat(s);
    };
    filtered.forEach((r) => {
      const rowNum = r.__rowNum || '?';
      const rowErrors = [];
      if (!r.comboName?.trim()) {
        rowErrors.push('"Combo Name" is empty');
      } else {
        if (r.comboName.trim().length > 100) rowErrors.push('"Combo Name" exceeds 100 characters');
      }
      if (!r.comboCode?.trim()) {
        rowErrors.push('"Combo Code" is empty');
      } else {
        if (r.comboCode.trim().length > 8) rowErrors.push('"Combo Code" exceeds 8 characters');
        if (!validateAlphanumeric(r.comboCode.trim())) rowErrors.push('"Combo Code" must be alphanumeric');
      }
      const priceNum = parsePrice(r?.comboPrice);
      if (!r.comboPrice?.toString()?.trim()) {
        rowErrors.push('"Combo Price" is empty');
      } else if (isNaN(priceNum) || priceNum < 1) {
        rowErrors.push('"Combo Price" must be a valid number >= 1');
      }
      if (r.items?.trim()) {
        const itemNames = r.items.split(',').map((s) => s.trim()).filter(Boolean);
        const unknownItems = itemNames.filter((n) => !itemNameSet.has(n.toLowerCase()));
        if (unknownItems.length > 0) rowErrors.push(`"Items" not found in system: ${unknownItems.join(', ')}`);
      }
      if (r.addOns?.trim()) {
        const addOnTypeVal = normalizeAddOnType(r?.addOnType) || inferAddOnTypeFromValue(r?.addOns);
        const rawAddons = r.addOns.trim();
        if (addOnTypeVal === 'grouped') {
          const groups = rawAddons.split('/').map((s) => s.trim()).filter(Boolean);
          groups.forEach((g) => {
            const parts = g.split('-');
            if (parts.length !== 3) {
              rowErrors.push(`"Add-Ons" grouped format invalid: '${g}' (expected: title-limit-addon1,addon2)`);
            } else {
              const listStr = (parts[2] || '').trim();
              const names = listStr.split(',').map((s) => s.trim()).filter(Boolean);
              const unknown = names.filter((n) => !addonNameSet.has(n.toLowerCase()));
              if (unknown.length > 0) rowErrors.push(`"Add-Ons" not found in system: ${unknown.join(', ')}`);
            }
          });
        } else if (addOnTypeVal === 'ungrouped') {
          let addonNames = [];
          if (rawAddons.includes('-')) {
            const parts = rawAddons.split('-');
            const listStr = (parts[1] || '').trim();
            addonNames = listStr.split(',').map((s) => s.trim()).filter(Boolean);
          } else {
            addonNames = rawAddons.split(',').map((s) => s.trim()).filter(Boolean);
          }
          const unknown = addonNames.filter((n) => !addonNameSet.has(n.toLowerCase()));
          if (unknown.length > 0) rowErrors.push(`"Add-Ons" not found in system: ${unknown.join(', ')}`);
        }
      }
      if (r.upsell?.trim()) {
        const upsellInfo = asBooleanOrList(r.upsell);
        if (upsellInfo.names.length > 0) {
          const unknownUpsell = upsellInfo.names.filter((n) => !itemNameSet.has(n.toLowerCase()));
          if (unknownUpsell.length > 0) rowErrors.push(`"Upsell" items not found in system: ${unknownUpsell.join(', ')}`);
        }
      }
      if (r.active?.trim() && !isValidStatus(r.active)) rowErrors.push('"Active" must be Yes or No');
      if (rowErrors.length > 0) errors.push(`Row ${rowNum}: ${rowErrors.join(', ')}`);
    });
    if (errors.length > 0) {
      setValidationErrors(errors);
      setCsvValidateError(true);
      return;
    }
    const duplicateErrors = [];
    const newItems = filtered.filter((r) => {
      const nameExists = combosList.findIndex((c) => (c?.name || '').trim().toLowerCase() === (r?.comboName || '').trim().toLowerCase()) > -1;
      const codeExists = combosList.findIndex((c) => (c?.code || '').trim().toLowerCase() === (r?.comboCode || '').trim().toLowerCase()) > -1;
      if (nameExists || codeExists) {
        const rowNum = r.__rowNum || '?';
        const reasons = [];
        if (nameExists) reasons.push(`name '${r.comboName.trim()}'`);
        if (codeExists) reasons.push(`code '${r.comboCode.trim()}'`);
        duplicateErrors.push(`Row ${rowNum}: Already exists (${reasons.join(' and ')})`);
        return false;
      }
      return true;
    });
    if (newItems.length === 0 && duplicateErrors.length > 0) {
      setValidationErrors(duplicateErrors);
      setCsvValidateError(true);
      setDataExistError(true);
      return;
    }
    const dataRows = newItems;
    const filterKnown = (namesArr, knownSet) =>
      (namesArr || [])?.map((s) => s && s?.toString()?.trim())?.filter(Boolean)?.filter((n) => knownSet?.has(n?.toLowerCase()));
    const toIdListByName = (wantedNames, source) => {
      const wantedSet = toLowerSet(wantedNames);
      return source?.filter((x) => wantedSet?.has(x.name?.toLowerCase()))?.map((e) => e.id);
    };
    const listToUpload = dataRows.map((r) => {
      const priceNum = parsePrice(r?.comboPrice);
      const itemNames = (r?.items || '')?.toString()?.split(',')?.map((s) => s?.trim())?.filter(Boolean);
      const knownItemNames = filterKnown(itemNames, itemNameSet);
      const itemIds = toIdListByName(knownItemNames, itemsListData);
      const upsellInfo = asBooleanOrList(r?.upsell);
      const upsellKnownNames = filterKnown(upsellInfo.names, itemNameSet);
      const upsellIds = toIdListByName(upsellKnownNames, itemsListData);
      const payload = {
        hotelId,
        code: r?.comboCode?.trim() || '',
        name: r?.comboName?.trim() || '',
        status: truthyWord(r?.active),
        price: priceNum,
        description: r?.description?.trim() || '',
        items: itemIds || [],
        addons: {},
        upsell: { status: upsellIds.length > 0, items: upsellIds || [] },
        restaurantId,
      };
      payload.addons = buildAddOns(r?.addOnType, r?.addOns, originalAddons, validateAlphanumeric);
      return payload;
    });
    setValidationErrors([]);
    setCsvValidateError(false);
    setDataExistError(false);
    handleCsvDataSubmit(listToUpload);
  };

  const handleCsvDataSubmit = async (payloadLists) => {
    setCsvUploadStatus('uploading');
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';

      for (const payload of payloadLists) {
        let addonsStatus = false;
        if (payload.addons && payload.addons.type) {
           if (payload.addons.type === IN_ROOM_DINING_COMBO_ADDONS_UNGROUPED || payload.addons.type === IN_ROOM_DINING_COMBO_ADDONS_GROUPED) {
              addonsStatus = true;
           }
        }
        
        const individualPayload = {
           hotelId: payload.hotelId,
           restaurantId: payload.restaurantId,
           code: payload.code,
           name: payload.name,
           status: payload.status,
           price: parseInt(payload.price, 10) || 0,
           description: payload.description || "",
           items: payload.items,
           addons: payload.addons,
           upsellStatus: payload.upsell ? payload.upsell.status : false,
           upsellItems: payload.upsell ? payload.upsell.items : [],
           images: [],
           customAttributes: [],
           addonsStatus: addonsStatus,
        };
        await createInRoomDiningCombo(individualPayload, language);
      }

      setCsvUploadStatus('success');
    } catch (e) {
      setCsvUploadErrorMsg(e?.graphQLErrors?.[0]?.message || e?.message || 'Server error');
      setCsvUploadStatus('server-error');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const generateAddonsData = (addons, type) => {
    if (type === IN_ROOM_DINING_COMBO_ADDONS_GROUPED) {
      return addons?.groupedAddon
        ?.map(
          (x) =>
            `${x.title}-${x.limit}-${originalAddons
              .filter((e) => x.addons.includes(e.id))
              .map((e) => e.name.toLowerCase())
              .toString()}`,
        )
        .toString();
    } else if (type === IN_ROOM_DINING_COMBO_ADDONS_UNGROUPED) {
      if (addons?.limit) {
        return `${addons.value}-${originalAddons
          .filter((e) => addons.addons && addons.addons?.includes(e.id))
          .map((e) => e.name.toLowerCase())
          .toString()}`;
      } else {
        return `${originalAddons
          .filter((e) => addons.addons && addons.addons?.includes(e.id))
          .map((e) => e.name.toLowerCase())
          .toString()}`;
      }
    }
  };

  const generateExportData = (combo) => {
    const tempList = combo?.map((e) => {
      const activeStatus = e?.status ? 'YES' : 'NO';
      const itemNames = itemsListData
        .filter((x) => e.items?.includes(x.id))
        .map((e) => e.name.toLowerCase())
        .join(',');
      const addOnType = e.addons.type.toLowerCase();
      const addOns = generateAddonsData(e.addons, addOnType);
      const upsells = e?.upsell?.status
        ? itemsListData
          .filter((x) => e?.upsell?.items?.includes(x.id))
          .map((e) => e.name.toLowerCase())
          .join(',')
        : '';

      return {
        ...e,
        active: `"${activeStatus}"`,
        items: `"${itemNames}"`,
        addOnType: `"${addOnType}"`,
        addOns: `"${addOns}"`,
        upsells: `"${upsells}"`,
      };
    });

    const fields = [
      'name',
      'code',
      'description',
      'price',
      'active',
      'items',
      'addOnType',
      'addOns',
      'upsells',
    ];

    return tempList.map((record) =>
      Object.fromEntries(
        Object?.entries(record)?.filter(([key, value]) =>
          fields?.includes(key) ? [key, "'" + value] : null,
        ),
      ),
    );
  };

  const generateHeaders = [
    { label: 'Combo Name', key: 'name' },
    { label: 'Combo Code', key: 'code' },
    { label: 'Description', key: 'description' },
    { label: 'Combo Price', key: 'price' },
    { label: 'Active', key: 'active' },
    { label: 'Items', key: 'items' },
    { label: 'Add On Type', key: 'addOnType' },
    { label: 'Add ons', key: 'addOns' },
    { label: 'Upsell', key: 'upsells' },
  ];

  const handleExport = () => {
    let selectedValue = combosList?.filter((combo) => combo?.isChecked);
    let exportData = [];
    let csvName = '';

    const propertyName = selectedHotel?.find((value) => value?.id === hotelId)?.name;

    if (selectedValue?.length === 1) {
      csvName = `${selectedValue[0].name}_ird_bundle.csv`;
      exportData = generateExportData(selectedValue);
    } else if (selectedValue?.length > 1) {
      csvName = `${propertyName}_ird_bundles.csv`;
      exportData = generateExportData(selectedValue);
    } else {
      csvName = `${propertyName}_ird_bundles.csv`;
      exportData = generateExportData(combosList);
    }

    const headers = generateHeaders?.map((header) => header?.label);
    const csvContent = [
      headers.join(','),
      ...exportData?.map((item) =>
        generateHeaders?.map((header) => item[header?.key] || '').join(','),
      ),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const anchor = document.createElement('a');
    anchor.href = window.URL.createObjectURL(blob);
    anchor.download = csvName;

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const handleAction = (actionName) => {
    let selectedbundle = combosList?.filter((combo) => combo?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedbundle?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedbundle?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedbundle?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      case 'Export':
        if (selectedbundle?.length > 0) {
          handleExport();
        }
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let index = combosList?.findIndex((item) => item.id === id);
    if (!combosList[index]?.isChecked) {
      combosList[index] = { ...combosList[index], isChecked: true };
    } else {
      combosList[index].isChecked = !combosList[index]?.isChecked;
    }
    setCombosList([...combosList]);

    let actionList = combosList
      ?.filter((combosList) => combosList?.isChecked)
      .map((status) => status?.status);

    const checkedItems = combosList?.filter((combosList) => combosList?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }
    if (!actionListName.includes('Export')) {
      actionListName.push('Export');
    }

    const isAllSelected = combosList?.every((item) => item?.isChecked);
    setIsAllSelected(isAllSelected);

    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    let selectedbundleList = combosList?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedbundleList?.some((combosList) => combosList?.status);
    const isInactive = selectedbundleList?.some((combosList) => !combosList.status);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }
    if (!actionListName.includes('Export')) {
      actionListName.push('Export');
    }

    setCombosList([...selectedbundleList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedbundleList.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Combo',
    listOfBundleIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_BUNDLE';
      await updateSelectedItemsStatus(
        listOfBundleIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        isActive,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'The status of the Combos was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_BUNDLE';
      await deleteSelectedItems(
        listOfBundleIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager('success', 'Combos Deleted Successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Combos Deletion Failed',
      );
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const handleBulkSearchAlertClose = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setCombosList(
      inRoomDiningCombos.map((res) => ({
        ...res,
        isChecked: false,
      })),
    );
  };

  return (
    <div className='mt-4 mb-4 group-list-container'>
      <Dialog fullScreen open={uploadState} onClose={handleUploadDialogClose}>
        <CsvUploader
          onClose={handleUploadDialogClose}
          pageTitle='Combo'
          onFileReadingComplete={(e) => handleCsvFileData(e)}
          csvUploadStatus={csvUploadStatus}
          validFormatError={csvValidateError}
          setValidFormatError={setCsvValidateError}
          dataExistError={dataExistError}
          setDataExistError={setDataExistError}
          listName='Combo'
          sectionTItle='Menu Configuration'
          csvUploadErrorMsg={csvUploadErrorMsg}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          downloadLink={DOWNLOAD_ASSETS_URL + '/cmsAssets/Menu+configs+Combo.xlsx'}
        />
      </Dialog>
      <SearchBar
        type={IN_ROOM_DINING_COMBO_CREATE}
        buttonName='Add Combo'
        setSearchText={handleSearchText}
        onOpenDrawer={onOpenDrawer}
        displayAddOrEdit={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
            ? !isHideAddButton
              ? 'show'
              : 'hide'
            : 'hide'
        }
        filterList={[]}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={combosList}
        setPlaceHolder={setCombosList}
        globalPlaceHolder={inRoomDiningCombos}
        setGlobalPlaceHolder={setInRoomDiningCombo}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='In-Room dining combo'
        module='IRD_BUNDLE'
        searchText={searchText}
        setSearch={setSearchText}
        extraSecondaryBtnDisplay={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
        }
        extraSecondaryBtnText='Upload'
        onClickSecondaryBtn={onClickUpload}
        // temporary disable
        // exportBtn
        // exportBtnTitle="Export"
        // headers={generateHeaders}
        // exportData={generateExportData(combosList)}
        handleAction={handleAction ?? false}
        actionMenuItems={actionMenuList ?? []}
      />
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {inRoomDiningLoader && (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        )}
        <InRoomDiningComboListTable
          page={page}
          dragDisabled={dragDisabled}
          rowsPerPage={rowsPerPage}
          onOpenDrawer={onOpenDrawer}
          onClickRowViewDetails={onClickRowViewDetails}
          onViewDetails={onViewDetails}
          selectedValue={selectedValue}
          handleClose={handleClose}
          handleCellMenuClick={handleCellMenuClick}
          combosList={combosList}
          setCombosList={setCombosList}
          permissions={permissions}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          onActiveDeActiveCombo={onActiveDeActiveCombo}
          onDeleteCombo={onDeleteCombo}
          setVisible={setVisible}
          searchText={searchText}
          handleSelectAll={handleSelectAll}
          handleCheckboxChange={handleCheckboxChange}
          isAllSelected={isAllSelected}
          setIsAllSelected={setIsAllSelected}
          setActionMenuList={setActionMenuList}
          selectedComboLength={selectedComboLength}
          inRoomDiningCombos={inRoomDiningCombos}
        />
      </div>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDelete}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      {selectedValue.id && selectedValue.warn && (
        <WarningPopup warningPopup={selectedValue} onWarningClose={handleClose} warn={true} />
      )}{' '}
      {showBulkSearchAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkSearchAlert}
          onClose={handleBulkSearchAlertClose}
          message="If you perform a search after making selections, the items you've selected will be lost."
          ButtonName='Cancel'
        />
      )}
      {showBulkKebabSelectionAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkKebabSelectionAlert}
          onClose={() => setShowBulkKebabSelectionAlert(false)}
          message='Please select one item from the list that you want to edit.'
          centerButtonName='OK'
        />
      )}
      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedComboLength} ${selectedComboLength > 1 ? 'combos' : 'combo'
            } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleSelection();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}
      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedComboLength}  ${selectedComboLength > 1 ? 'combos' : 'combo'
            } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}
    </div>
  );
};

export default InRoomDiningComboList;
